<template>
  <div class="palm_configuration_page" >
    <el-button type="primary" size="mini" icon="el-icon-back" @click="$router.push('/')">返回</el-button>
    <el-divider content-position="left">掌上办小程序配置管理</el-divider>
    <div>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-button round @click="$router.push('/palm_contract')">合同管理</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PalmConfigurationPage',
  data () {
    return {
    	foldStyle: {
    	  marginLeft: '1.25rem !important',
    	},
    	unFoldStyle: {
    	  marginLeft: '3.6rem !important',
    	}
    }
  },
  computed: {
    collapse() {
      return this.$store.state.collapse
    },
  },
  methods: {},
  mounted () {}
}
</script>

<style lang="stylus" scoped>
.palm_configuration_page {
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}
.clearfix:after {
  clear: both;
}
#forStyle >>> .demo-table-expand {
  font-size: 0;
}
#forStyle >>> .demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
#forStyle >>> .demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/miniProZhangShangBanConfig/PalmConfigurationPage.vue